import * as d3 from 'd3'
export default {
  methods: {

    draw_Header() {
      
      let head = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.table.x}, ${this.table.y})`)

      this.columns.forEach((d,i)=> {
        
        if(d.group) {
          let x = d.sx + (this.columns[i+d.span-1].ex - d.sx)/2
          head
          .append('text')
          .attr('x', x).attr('y', 20)
          .attr('font-size', 11).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.group)
        }
        if(i>1) {
          head
          .append('text')
          .attr('x', d.mx).attr('y', d.type ? 40 : 45)
          .attr('font-size', 9).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.name)
          if(d.type) this.tbl_Grid(head, d)
        } else {
          head
          .append('text')
          .attr('x', d.mx).attr('y', 36)
          .attr('font-size', 11).attr('fill', d.code == 'SUBSYS' ? '#44A9DF' : '#333')
          .attr('text-anchor', 'middle')
          .text(d.name)
        }
        if(d.vLine == 1) this.gmx_Line(head, d.ex, d.ex, 5, this.table.height,  '#E0E0DF', .75, 1)
      })

      this.gmx_Line(head, this.columns[1].ex, this.table.width, 28,  28,  '#E0E0DF', 1, 1)
      this.gmx_Line(head, 0, this.table.width, 6,  6,  '#757575', .5, 1)
      this.gmx_Line(head, 0, this.table.width, this.table.headHeight, this.table.headHeight, '#757575', .5, 1)
      this.gmx_Line(head, 0, this.table.width, this.table.height, this.table.height, '#757575', .5, 1)
    },


    tbl_Grid(selection, col) {
      selection
      .append('text')
      .attr('x', col.sx).attr('y', 55)
      .attr('font-size', 9).attr('fill', '#bcbcbc')
      .attr('text-anchor', 'middle')
      .text(0)

      selection
      .append('text')
      .attr('x', col.mx).attr('y', 55)
      .attr('font-size', 9).attr('fill', '#bcbcbc')
      .attr('text-anchor', 'middle')
      .text(col.type=='PRO' ? 50 : this.punch[col.type]/2)

      selection
      .append('text')
      .attr('x', col.sx+100).attr('y', 55)
      .attr('font-size', 9).attr('fill', '#bcbcbc')
      .attr('text-anchor', 'middle')
      .text(col.type=='PRO' ? 100 : this.punch[col.type])
    },

  }
}